<template>
  <subgame3Dian8 v-if="['3.8','3.8_2'].includes($store.state.config.ui_version)"></subgame3Dian8>
  <subgame v-else></subgame>
</template>

<script>
import subgame3Dian8 from './subgame3.8.vue';
import subgame from './subgame.vue';
export default {
  components: {
    subgame3Dian8,
    subgame
  }
};
</script>
